import { Grid, Popover, styled, Typography } from "@mui/material";

import { BasicButton } from "components/buttons/basic-button";

import { pointer, StylingRelatedConstants } from "config";

import { PopoverMode } from "./enums";
import { IPopoverProps } from "./types";
import { getPopoverArrowTransform } from "./utils";

export const StyledPopover = styled(Popover, {
  shouldForwardProp: (prop) => prop !== "arrowPosition" && prop !== "mode",
})<Pick<IPopoverProps, "arrowPosition" | "mode">>(
  ({ theme, arrowPosition, mode }) => ({
    zIndex: theme.zIndex.modal + 3,
    "> .MuiPaper-root": {
      backgroundColor: theme.palette.custom.light_dark,
      borderRadius: theme.shape.borderRadius[3],
      maxWidth: theme.typography.pxToRem(217),
      width: "100%",
      ...(mode === PopoverMode.LIGHT && {
        filter: "drop-shadow(0px 3px 17px rgba(0, 0, 0, 0.15))",
        backgroundColor: theme.palette.custom.lighter_gray,
      }),
      ...(arrowPosition && {
        transform: getPopoverArrowTransform(arrowPosition),
        "&::before": {
          position: "absolute",
          content: '""',
          top: "17px",
          left: "-7px",
          borderTop: "6px solid transparent",
          borderBottom: "6px solid transparent",
          borderRight: `10px solid ${theme.palette.custom.light_dark}`,
          ...(arrowPosition === "top-right" && {
            transform: "rotate(90deg)",
            top: "-10px",
            left: "unset",
            right: "24px",
          }),
          ...(arrowPosition === "top-center" && {
            top: "-5px",
            left: "50%",
            transform: "rotate(90deg) translateX(-50%)",
          }),
        },
      }),
      "& h6 + div:first-of-type": {
        borderRadius: 0,
      },
    },
  })
);

export const StyledPopoverOption = styled(BasicButton, {
  shouldForwardProp: (prop) => prop !== "mode",
})<Pick<IPopoverProps, "mode">>(({ theme, mode = PopoverMode.DARK }) => ({
  height: StylingRelatedConstants.HEIGHT_38,
  justifyContent: "flex-start",
  minWidth: 0,
  color:
    mode === PopoverMode.DARK
      ? theme.palette.custom.white
      : theme.palette.custom.light_dark,
  alignItems: "center",
  gap: theme.spacing(4),
  paddingLeft: theme.spacing(4),
  display: "flex",
  borderRadius: "0",
  ...pointer,
  "svg:not(.reset-icon)": {
    path: {
      fill:
        mode === PopoverMode.DARK
          ? theme.palette.custom.white
          : theme.palette.custom.light_dark,
    },
  },
  "&:hover": {
    backgroundColor:
      mode === PopoverMode.DARK
        ? theme.palette.custom.default_dark
        : theme.palette.custom.dark_gray,
  },
}));

StyledPopoverOption.defaultProps = { variant: "text" };

export const StyledCustomizedPopoverGridOverflow = styled(Grid)({
  overflow: "hidden",
  borderRadius: "inherit",
});

export const StyledCustomizedPopoverGridFlexDirection = styled(Grid)(
  ({ theme }) => ({
    flexDirection: "column",
    paddingBottom: theme.spacing(2),
  })
);

// Preserve existing 13px spacing during extraction.
export const StyledCustomizedPopoverTypography = styled(Typography)(
  ({ theme }) => ({
    padding: `${`calc(${theme.spacing(1)} * 3.25)`} ${theme.spacing(
      4
    )} ${theme.spacing(4)}`,
    ...{ textTransform: "uppercase" },
  })
);
